import * as React from 'react';

import { PropertyAboutThisProperty } from '@shared-ui/lodging-property-details';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './shared-ui-property-details';
import { SimpleLazyLoadWrapper } from 'src/common/components/common/lazy/simple-lazy-load-wrapper';

interface AboutThisPropertyProps extends SharedUiWrapperProps {
  columns?: number;
}

const AboutThisPropertyWrapper: React.FC<AboutThisPropertyProps> = ({ inputs, columns }) => (
  <UitkSpacing margin={{ block: 'six' }}>
    <SimpleLazyLoadWrapper>
      <PropertyAboutThisProperty inputs={inputs} columns={columns} />
    </SimpleLazyLoadWrapper>
  </UitkSpacing>
);

export const SharedUiAboutThisPropertyWrapper = withSharedUiPropertyDetails<Omit<AboutThisPropertyProps, 'inputs'>>(
  AboutThisPropertyWrapper
);
SharedUiAboutThisPropertyWrapper.displayName = 'SharedUiAboutThisPropertyWrapper';
